import { useCallback, useEffect, useState } from "react";

const KEY = "virtue.abm_scope";
const VALID = new Set(["abm", "all"]);

/**
 * Persistent segmented data-scope selector.
 *   "abm" — original Target Account List only (default).
 *   "all" — every record, including future broader HubSpot imports.
 */
export function useAbmScope() {
  const [scope, setScopeState] = useState(() => {
    try {
      const v = window.localStorage.getItem(KEY);
      return VALID.has(v) ? v : "abm";
    } catch {
      return "abm";
    }
  });

  const setScope = useCallback((next) => {
    if (!VALID.has(next)) return;
    setScopeState(next);
  }, []);

  useEffect(() => {
    try {
      window.localStorage.setItem(KEY, scope);
    } catch {
      /* ignore quota / privacy errors */
    }
  }, [scope]);

  return { scope, setScope };
}
